import {template as tpl, viewModel as PrivacyPolicy} from "./policy";
import {global} from "../../appContext";
import policy_pageHtml from './policy-page.html?raw';

export let template = policy_pageHtml;

export class viewModel extends PrivacyPolicy {
    template = tpl;

    private organizationName = global.login.selectedOrganization()?.organizationame ?? '';
    private organizationId = global.login.selectedOrganization()?.organizationid ?? '';
}
